<template>
  <div class="qr-code-wrapper">
    <pay-title :order-info="orderInfo"></pay-title>
    <div v-if="tradeType === 6">
      <iframe class="pay-iframe" ref="payIframe"></iframe>
    </div>
    <div v-else class="qr-code">
      <img :src="`data:image/png;base64,${payInfo.payData}`" />
    </div>
    <div v-if="payMethod === 2 || payMethod === 6" class="method method-alipay">
      使用支付宝扫码付款
    </div>
    <div v-else class="method method-wechat">使用微信扫码付款</div>
  </div>
</template>

<script>
import PayTitle from '@/components/CashierDesk/PayTitle'

export default {
  name: 'PayQrCode',
  components: { PayTitle },
  props: ['orderInfo', 'payMethod', 'payInfo', 'tradeType'],
  data() {
    return {
      iframeEl: null
    }
  },
  mounted() {
    this.initIframe()
  },
  methods: {
    initIframe() {
      if (this.$refs.payIframe.contentWindow === null) {
        setTimeout(this.initIframe)
        return
      }

      const iframeDoc = this.$refs.payIframe.contentWindow.document
      iframeDoc.open().write(
        `
          <body>${this.payInfo.payData}</body>
          <script>
           document.querySelector('#alipaysubmit').submit();
         <\\/script>
          `
      )
      iframeDoc.close() // iframe onload event happens
    }
  }
}
</script>

<style lang="scss" scoped>
.qr-code-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.qr-code {
  display: inline-block;
  border: 1px solid #dedede;
  padding: 10px;
  margin: 0 auto;

  img {
    display: block;
    width: 160px;
  }
}

.method {
  padding-left: 42px;
  margin-top: 10px;
  background: no-repeat left;
  background-size: 32px auto;
  line-height: 40px;
  font-size: 14px;
  color: #262626;
}

.method-alipay {
  background-image: url('~@/assets/images/cashier-desk/alipay.png');
}

.method-wechat {
  background-image: url('~@/assets/images/cashier-desk/wechat.png');
}

.pay-iframe {
  width: 162px;
  height: 166px;
  border: none;
  overflow: hidden;
  background-color: #fafafa;
}
</style>
